import { render, staticRenderFns } from "./holy-grail.template.html?vue&type=template&id=29c4dd3e&scoped=true&"
var script = {}
import style0 from "./holy-grail.template.vue?vue&type=style&index=0&id=29c4dd3e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29c4dd3e",
  null
  
)

export default component.exports